<script>

    import { userStore, modalStore } from '../stores'

    import Modal from '../$components/modal.container.svelte'

    import Account from '../accounts/component.account.svelte'
    import AccountCreate from '../accounts/component.create.svelte'
    import AccountUpdate from '../accounts/component.update.svelte'
    import Charge from '../charges/component.charge.svelte'
    import ChargeCreate from '../charges/component.create.svelte'
    import ChargeUpdate from '../charges/component.update.svelte'
    import Credit from '../credits/component.credit.svelte'
    import CreditCreate from '../credits/component.create.svelte'
    import CreditUpdate from '../credits/component.update.svelte'
    import Notification from '../notifications/component.notification.svelte'
    import NotificationCreate from '../notifications/component.create.svelte'
    import NotificationUpdate from '../notifications/component.update.svelte'
    import Notice from '../notices/component.notice.svelte'
    import NoticeCreate from '../notices/component.create.svelte'
    import NoticeUpdate from '../notices/component.update.svelte'
    import Prepaid from '../prepaids/component.prepaid.svelte'
    import PrepaidCreate from '../prepaids/component.create.svelte'
    import PrepaidUpdate from '../prepaids/component.update.svelte'
    import Price from '../prices/component.price.svelte'
    import PriceCreate from '../prices/component.create.svelte'
    import PriceUpdate from '../prices/component.update.svelte'
    import UserUpdate from './component.update.svelte'

</script>

<Modal id="user_update_modal" title="Actualizar Usuario">
    <UserUpdate />
</Modal>

<Modal id="credit_create_modal" title="Agregar Crédito">
    <CreditCreate />
</Modal>

<Modal id="credit_modal" title="Información Crédito">
    <Credit />
</Modal>

<Modal id="credit_update_modal" title="Actualizar Crédito">
    <CreditUpdate />
</Modal>

<Modal id="charge_create_modal" title="Crear Cargo">
    <ChargeCreate />
</Modal>

<Modal id="charge_modal" title="Información Cargo">
    <Charge />
</Modal>

<Modal id="charge_update_modal" title="Actualizar Cargo">
    <ChargeUpdate />
</Modal>

<Modal id="prepaid_create_modal" title="Crear Prepago">
    <PrepaidCreate type="user" />
</Modal>

<Modal id="prepaid_modal" title="Información Prepago">
    <Prepaid />
</Modal>

<Modal id="prepaid_update_modal" title="Actualizar Prepago">
    <PrepaidUpdate />
</Modal>

<Modal id="account_create_modal" title="Crear Cuenta">
    <AccountCreate />
</Modal>

<Modal id="account_modal" title="Información Cuenta">
    <Account />
</Modal>

<Modal id="account_update_modal" title="Actualizar Cuenta">
    <AccountUpdate />
</Modal>

<Modal id="notification_create_modal" title="Crear Notificación">
    <NotificationCreate type="user" />
</Modal>

<Modal id="notification_modal" title="Información Notificación">
    <Notification />
</Modal>

<Modal id="notification_update_modal" title="Actualizra Notificación">
    <NotificationUpdate />
</Modal>

<Modal id="notice_modal" title="Aviso">
    <Notice />
</Modal>

<Modal id="notice_create_modal" title="Crear aviso">
    <NoticeCreate userId={$userStore._id} />
</Modal>

<Modal id="notice_update_modal" title="Actualizar aviso">
    <NoticeUpdate />
</Modal>

<Modal id="price_modal" title="Información Precio">
    <Price />
</Modal>

<Modal id="price_create_modal" title="Crear Precio">
    <PriceCreate userId={$userStore._id} />
</Modal>

<Modal id="price_update_modal" title="Actualizar Precio">
    <PriceUpdate />
</Modal>